// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roi-calculator {
    padding: 20px;
    background-color: #1a202c;
    color: white;
    min-height: 100vh;
    font-family: Arial, sans-serif;
  }
  
  .card {
    background-color: #2d3748;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
  }
  
  .input-group {
    margin-bottom: 10px;
  }
  
  .input-group label {
    display: block;
    margin-bottom: 5px;
  }
  
  .input {
    width: 100%;
    padding: 8px;
    background-color: #4a5568;
    color: white;
    border: none;
    border-radius: 4px;
  }
  
  .button {
    padding: 8px 16px;
    background-color: #4299e1;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .button.calculate {
    display: block;
    width: 100%;
    margin-top: 20px;
  }
  
  .tabs {
    display: flex;
    margin-bottom: 16px;
  }
  
  .tab {
    padding: 8px 16px;
    background-color: #4a5568;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  .tab.active {
    background-color: #2b6cb0;
  }
  
  .results {
    background-color: #2b6cb0;
  }

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotate-logo {
  transition: transform 0.3s ease;
}

.rotate-logo:hover {
  animation: rotate 3s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/ROICalculator.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".roi-calculator {\n    padding: 20px;\n    background-color: #1a202c;\n    color: white;\n    min-height: 100vh;\n    font-family: Arial, sans-serif;\n  }\n  \n  .card {\n    background-color: #2d3748;\n    border-radius: 8px;\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n  \n  .input-group {\n    margin-bottom: 10px;\n  }\n  \n  .input-group label {\n    display: block;\n    margin-bottom: 5px;\n  }\n  \n  .input {\n    width: 100%;\n    padding: 8px;\n    background-color: #4a5568;\n    color: white;\n    border: none;\n    border-radius: 4px;\n  }\n  \n  .button {\n    padding: 8px 16px;\n    background-color: #4299e1;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .button.calculate {\n    display: block;\n    width: 100%;\n    margin-top: 20px;\n  }\n  \n  .tabs {\n    display: flex;\n    margin-bottom: 16px;\n  }\n  \n  .tab {\n    padding: 8px 16px;\n    background-color: #4a5568;\n    color: white;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .tab.active {\n    background-color: #2b6cb0;\n  }\n  \n  .results {\n    background-color: #2b6cb0;\n  }\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rotate-logo {\n  transition: transform 0.3s ease;\n}\n\n.rotate-logo:hover {\n  animation: rotate 3s linear infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
